import { render, staticRenderFns } from "./list_products_saller.vue?vue&type=template&id=469a201a&"
import script from "./list_products_saller.vue?vue&type=script&lang=js&"
export * from "./list_products_saller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports